// Transient "Joining call…" surface — appears between Accept and the live
// in-call view. For this piece, it's a static placeholder (no LiveKit join
// yet); the live-media wiring is the next dispatch, which will replace this
// surface entirely once the InCallSurface mounts on a 'group-active' state.
// Same card chrome as the other ring surfaces so the transition into
// joining doesn't flash a different design.
//
// Intentionally has NO buttons in this piece — the next-piece state
// machine surfaces a proper end-call control. The session subscription
// already drives teardown if the call gets canceled remotely, so the user
// is never permanently stuck here.

import { useCallManager } from '@/lib/callManager'

export function GroupJoiningOverlay() {
  const { state } = useCallManager()
  if (state.kind !== 'group-joining') return null
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Joining group call"
      style={{
        position: 'fixed', inset: 0,
        background: 'var(--overlay-scrim)', backdropFilter: 'blur(8px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 500, padding: 16,
      }}
    >
      <div
        className="call-card-enter"
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--border-default)',
          borderRadius: 20, padding: 32,
          width: '100%', maxWidth: 380,
          boxShadow: 'var(--shadow-popover-mid)',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18,
        }}
      >
        {/* Label — "Joining" + animated ellipsis (reuses OutgoingCallOverlay's keyframes) */}
        <div
          aria-live="polite"
          style={{
            color: 'var(--ink-tertiary)',
            display: 'inline-flex', alignItems: 'baseline', gap: 1,
          }}
        >
          <span style={{
            fontSize: 11, fontWeight: 700,
            textTransform: 'uppercase', letterSpacing: '0.1em',
          }}>
            Joining call
          </span>
          <span aria-hidden="true" style={{ display: 'inline-flex', gap: 1, marginLeft: 4 }}>
            <span className="call-ellipsis-dot" style={{ fontSize: 11, fontWeight: 700, animationDelay: '0ms'   }}>.</span>
            <span className="call-ellipsis-dot" style={{ fontSize: 11, fontWeight: 700, animationDelay: '200ms' }}>.</span>
            <span className="call-ellipsis-dot" style={{ fontSize: 11, fontWeight: 700, animationDelay: '400ms' }}>.</span>
          </span>
        </div>

        <p style={{
          fontSize: 13, color: 'var(--ink-secondary)', margin: 0,
          textAlign: 'center',
        }}>
          Connecting to the room…
        </p>
      </div>
    </div>
  )
}
